var React = require('react');

function Minus12x12 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Color=Black, State=Minus, Size=12x12"},React.createElement("path",{"id":"Vector","d":"M11 6H1","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"})));
}

Minus12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Minus12x12;

Minus12x12.default = Minus12x12;
